import React from 'react';
import { Icon, IconNames } from '@sovryn/ui';
export const GoBackButton = ({ onClick, disabled, }) => (React.createElement("button", { onClick: onClick, disabled: disabled, className: "mb-12 md:mb-0 disabled:opacity-60" },
    React.createElement(Icon, { icon: IconNames.ARROW_LEFT, className: "w-3 h-3" })));
